import React from "react";
import { A4Estimate, Extras } from "../Quote";

export const BlankProjectNumbers = ({ project, team }) => {
  if (!team || !team.tierLimits.seePrices) return null;

  return (
    <>
      <Extras />

      <A4Estimate
        key={`${project.id}-estimate`}
        project={project}
        clientName={`${project.clientFirstName || ""} ${project.clientLastName || ""}`}
        address={project.address}
        city={project.city}
        state={project.state}
        notes={project.notes}
        lineItems={[...(project?.extras || [])]}
        team={team}
        design={{}}
        pricePerFtBeforeTax={0}
      />
    </>
  );
};
